import { render, staticRenderFns } from "./DynamicPage.vue?vue&type=template&id=1f14cd82&"
import script from "./DynamicPage.vue?vue&type=script&lang=js&"
export * from "./DynamicPage.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPage.vue?vue&type=style&index=0&id=1f14cd82&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports